import { DefaultPreview } from './DefaultPreview'
import { PreviewProps } from './Types'
import { WebsitePreview } from './WebsitePreview'

export const Preview = ({ brandKit }: PreviewProps) => {
  const { websites } = brandKit

  if (websites.length > 0) {
    return <WebsitePreview brandKit={brandKit} website={websites[0]} />
  }

  return <DefaultPreview brandKit={brandKit} />
}
